import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { xml2js } from 'xml-js';

@Injectable({
  providedIn: 'root'
})
export class ChatLayerService {

  private url = '';
  private soapRequestXML: any;
  private http = inject(HttpClient);

  constructor() { }

  getChatLink() {
    const headers = {
      'Content-Type': 'text/xml',
      'Access-Control-Allow-Origin': '*'
    };

    const options: any = {
      observe: 'body',
      headers,
      responseType: 'text'
    };

    this.soapRequestXML = this.soapRequest();

    return this.http.post(this.url, this.soapRequestXML, options);
  }

  getSoapRequestXML() {
   return this.soapRequestXML;
  }

  private soapRequest() {
   return``;
  }

  xmlToJson(xml: any): Object {
    return xml2js(xml,
      {
       compact: true,
       trim: true,
       alwaysChildren: true,
       ignoreInstruction: true,
       ignoreDeclaration: true,
       ignoreAttributes: true,
       ignoreComment: true,
       ignoreCdata: true,
       ignoreDoctype: true,
      });
  };

}